import { Navigate, Outlet } from 'react-router-dom'

import { viewerModel } from '~/entities/viewer'
import { DEFAULT_REGION_OPTION } from '~/shared/config/constants'
import { history } from '~/shared/lib/history'
import { filterHelpers } from '~/shared/ui/ScrollableList'

export function ProtectedPage() {
  const authenticated = viewerModel.useAuthenticated()

  const regionFilter = `regionCode=${filterHelpers.encodeOption(
    DEFAULT_REGION_OPTION,
  )}`
  const loginUrl = `/booking-cars?${regionFilter}`

  return authenticated ? (
    <Outlet />
  ) : (
    <Navigate to={loginUrl} state={{ from: history.location }} />
  )
}
